// Models Login
import { useState } from "react";
import { useNavigate } from "react-router";
import apiAuth from "../api/Auth/api-auth";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { Login } from "../models/LoginModel/login.model";
import { UseVerConvocatorias } from "./UseVerConvocatorias";
import { useEncrypt } from "./useEncrypt"

export const useLoginForm = () => {
  const navigate = useNavigate();
  const [errorMsj, setErrorMsj] = useState<boolean>(false);
  const { inscribirPropuesta } = UseVerConvocatorias();
  const [mensajeError, setMensajeError] = useState("");
  const { encrypt } = useEncrypt();

interface response {
  results: any;
  message: string;
}

  const getErrorMessage = (message: string): string | null => {
    if (message === "Invalid password") {
      return "La contraseña actual en el sistema no coincide con la contraseña ingresada en el formulario";
    }
    if (message.indexOf('Could not find user') >= 0) {
      return "El usuario no existe, por favor regístrate.";
    }
    if (message.indexOf('incorrectos') >= 0) {
      return message;
    }
    if (message === "El usuario se encuentra bloqueado. Demasiados intentos fallidos") {
      return "Escribíste tu contraseña 5 veces de manera incorrecta, vuelve a intentarlo más tarde (2 Horas a partir de tu último intento)";
    }
    return null;
  };

  const routeAfterLogin = async (
    screen: string | undefined,
    id: string | undefined,
    message: string
  ) => {
    if (message === "El usuario requiere cambio de contraseña") {
      return navigate("/usuario/CambiarContrasena");
    }

    if (screen === undefined) {
      return navigate("/usuario/");
    }

    if (id !== undefined) {
      localStorage.setItem("idConvocatoriaPostulacion", encrypt(id.toString()));
    }

    if (screen === "1") {
      if (id === undefined) return navigate("/usuario/");
      const data = await apiConvocatorias.getConvocatoriaById(id);
      inscribirPropuesta(data.data, data.user);
      return navigate("/usuario/Seleccionarrol");
    }
    if (screen === "3") return navigate("/usuario/Inscribirhojadevida");

    return navigate("/usuario/");
  };

  const onFinish = async (
    data: Login,
    screen: string | undefined,
    id: string | undefined
  ) => {
    try {
      const res: any = await apiAuth.Login(data);
      const { results, message } = res;

      const errMsg = getErrorMessage(message);
      if (errMsg) {
        setMensajeError(errMsg);
        return setErrorMsj(true);
      }

      if (results?.user?.inactive) {
        setMensajeError("El usuario no se encuentra activo");
        return setErrorMsj(true);
      }

      if (results?.token) {
        localStorage.setItem("token", results?.token);
      }

      if (results?.user) {
        const encryptUserStorage = encrypt(JSON.stringify(results?.user));
        localStorage.setItem("user", encryptUserStorage);
      }

      if (message === "El usuario requiere cambio de contraseña") {
        return navigate("/usuario/CambiarContrasena");
      }

      if (Number(results?.user?.role_id) === 2 || Number(results?.user?.role_id) === 1) {
        return navigate("/administrador");
      }

      return routeAfterLogin(screen, id, message);
    } catch (error: any) {
      if (error?.message?.indexOf('Could not find user') >= 0) {
        setMensajeError("El usuario no existe, por favor regístrate.");
        return setErrorMsj(true);
      }
      console.log(error);
      setMensajeError("Hubo un error al intentar loguearte en el sistema Intentalo más tarde");
      return setErrorMsj(true);
    }
  };
  return { onFinish, errorMsj, errormsj: errorMsj, setErrorMsj, mensajeError, setMensajeError };
};
